const ProfileSectionHelpers = {
    cols: { xs: 1, sm: 2, md: 2, lg: 3, xl: 4, xxl: 4 },
};

export { ProfileSectionHelpers };
